import { useState ,useRef} from "react";
import { colorClasses } from "../../utils";
import Feedback from "../Feedback";
import ActionButtons from "../ActionButtons";
import correct from "../../assets/sounds/correct.wav"
import wrong from "../../assets/sounds/wrong.wav"
import retry from "../../assets/sounds/retry.wav"
import check from "../../assets/sounds/check.wav"
const CountAndInputExercise = ({ exercise }) => {
  const [state, setState] = useState(Array(exercise.groups.length).fill('؟'));
  const [feedback, setFeedback] = useState(null);
  const correctSound = useRef(new Audio(correct))
  const wrongSound = useRef(new Audio(wrong))
  const retrySound = useRef(new Audio(retry))
  const checkSound = useRef(new Audio(check))
  const handleClick = (index) => {
    const currentIndex = exercise.numbers.indexOf(state[index]);
    const nextIndex = (currentIndex + 1) % exercise.numbers.length;
    const newState = [...state];
    newState[index] = exercise.numbers[nextIndex];
    checkSound.current.currentTime = 0;
    checkSound.current.play();
    setState(newState);
    setFeedback(null);
  };

  const handleCheck = () => {
    const isCorrect = JSON.stringify(state) === JSON.stringify(exercise.correctAnswer);
    if(isCorrect){
        correctSound.current.currentTime = 0;
        correctSound.current.play()
    }else{
        wrongSound.current.currentTime = 0;
        wrongSound.current.play()
    }
    setFeedback({
      type: isCorrect ? 'success' : 'error',
      message: isCorrect ? exercise.successMessage : exercise.errorMessage
    });
  };

  const handleReset = () => {
    retrySound.current.currentTime = 0;
    retrySound.current.play()
    setState(Array(exercise.groups.length).fill('؟'));
    setFeedback(null);
  };

  return (
    <>
      <div className="space-y-4 sm:space-y-6">
       {exercise.groups.map((group, idx) => (
  <div key={idx} className="flex flex-col sm:flex-row gap-3 sm:gap-8 items-center justify-center">
    <div className="flex flex-wrap justify-center gap-2 sm:gap-3 max-w-full">
      {Array(group.count).fill(0).map((_, i) => (
        <div key={i} className="text-4xl sm:text-6xl">{group.emoji}</div>
      ))}
    </div>
    <div className="text-2xl sm:text-4xl font-bold mt-2 sm:mt-0">=</div>
    <div
      onClick={() => handleClick(idx)}
      className={`w-14 h-14 sm:w-20 sm:h-20 border-2 sm:border-4 rounded-xl sm:rounded-2xl flex items-center justify-center text-2xl sm:text-4xl font-bold cursor-pointer transition-all hover:scale-105 ${
        state[idx] !== '؟' ? 'border-teal-500 bg-teal-50' : 'border-gray-500 bg-white'
      }`}
    >
      {state[idx]}
    </div>
  </div>
))}

      </div>
      <ActionButtons onCheck={handleCheck} onReset={handleReset} />
      <Feedback feedback={feedback} />
    </>
  );
};

export default CountAndInputExercise;